import React from 'react';

export const Instagram = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_12387_8315)" />
      <g clipPath="url(#clip0_12387_8315)">
        <path
          d="M17.9639 9.52625C17.9347 8.88757 17.8333 8.45142 17.685 8.06982C17.5344 7.66946 17.2982 7.30682 16.9929 7.00708C16.6933 6.70184 16.3305 6.46555 15.9302 6.31485C15.5485 6.16663 15.1124 6.06528 14.4738 6.03625C13.8339 6.00696 13.6295 6 12 6C10.3705 6 10.1661 6.00696 9.52625 6.03607C8.88757 6.06528 8.45151 6.16672 8.06982 6.31503C7.66946 6.46564 7.30682 6.70184 7.00708 7.00708C6.70184 7.30673 6.46555 7.66937 6.31485 8.06973C6.16663 8.45142 6.06528 8.88757 6.03625 9.52615C6.00696 10.1661 6 10.3705 6 11.9999C6 13.6295 6.00696 13.8339 6.03625 14.4738C6.06537 15.1123 6.16681 15.5485 6.31512 15.9302C6.46573 16.3304 6.70193 16.6932 7.00717 16.9928C7.30682 17.2981 7.66956 17.5343 8.06992 17.6849C8.45151 17.8333 8.88766 17.9346 9.52634 17.9638C10.1663 17.993 10.3706 17.9999 12.0001 17.9999C13.6295 17.9999 13.834 17.993 14.4738 17.9638C15.1125 17.9346 15.5486 17.8333 15.9303 17.6849C16.7362 17.3732 17.3733 16.7361 17.685 15.9302C17.8334 15.5485 17.9347 15.1123 17.9639 14.4738C17.993 13.8338 18 13.6295 18 12C18 10.3705 17.993 10.1661 17.9639 9.52625ZM16.8839 14.4246C16.8572 15.0096 16.7595 15.3273 16.6773 15.5387C16.4755 16.062 16.0619 16.4756 15.5386 16.6774C15.3272 16.7596 15.0095 16.8573 14.4245 16.884C13.792 16.9129 13.6022 16.9189 12 16.9189C10.3977 16.9189 10.208 16.9129 9.57541 16.884C8.99048 16.8573 8.67279 16.7596 8.4613 16.6774C8.20074 16.5812 7.965 16.4279 7.77145 16.2285C7.57214 16.035 7.41879 15.7993 7.32257 15.5387C7.24045 15.3273 7.14267 15.0096 7.11603 14.4246C7.08719 13.792 7.08105 13.6022 7.08105 12.0001C7.08105 10.3979 7.08719 10.2082 7.11603 9.5755C7.14276 8.99048 7.24045 8.67279 7.32257 8.4614C7.41879 8.20074 7.57224 7.965 7.77145 7.77145C7.965 7.57214 8.20074 7.41879 8.4614 7.32266C8.67279 7.24045 8.99048 7.14276 9.5755 7.11603C10.2081 7.08719 10.3979 7.08105 12 7.08105H11.9999C13.602 7.08105 13.7918 7.08719 14.4245 7.11612C15.0095 7.14276 15.3271 7.24054 15.5386 7.32266C15.7992 7.41888 16.0349 7.57224 16.2285 7.77145C16.4278 7.965 16.5811 8.20074 16.6772 8.4614C16.7595 8.67279 16.8572 8.99048 16.8839 9.5755C16.9127 10.2081 16.9189 10.3979 16.9189 12C16.9189 13.6022 16.9128 13.7919 16.8839 14.4246Z"
          fill="white"
        />
        <path
          d="M11.999 8.91895C10.2974 8.91895 8.91797 10.2985 8.91797 12.0001C8.91797 13.7017 10.2974 15.0811 11.999 15.0811C13.7007 15.0811 15.0801 13.7017 15.0801 12.0001C15.0801 10.2985 13.7007 8.91895 11.999 8.91895ZM11.999 14C10.8945 13.9999 9.99902 13.1046 9.99911 12C9.99911 10.8955 10.8945 10 11.9991 10C13.1037 10.0001 13.9991 10.8955 13.9991 12C13.9991 13.1046 13.1036 14 11.999 14Z"
          fill="white"
        />
        <path
          d="M15.9225 8.79721C15.9225 9.19482 15.6001 9.51718 15.2025 9.51718C14.8048 9.51718 14.4824 9.19482 14.4824 8.79721C14.4824 8.39951 14.8048 8.07715 15.2025 8.07715C15.6001 8.07715 15.9225 8.39951 15.9225 8.79721Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_12387_8315"
          x1="2.01404"
          y1="21.9859"
          x2="21.9861"
          y2="2.01401"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFD600" />
          <stop offset="0.5" stopColor="#FF0100" />
          <stop offset="1" stopColor="#D800B9" />
        </linearGradient>
        <clipPath id="clip0_12387_8315">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
